// src/services/api/inventory.js
// Equip, unequip, use item, ammo, item inspect, and guild deposit operations.

import { fetchWithCommonHeaders, API_URL } from './helpers';

export const fetchItemInspect = async (token, itemCode) => {
    const url = `${API_URL}v2/item/inspect`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode }
    });

    if (!response.ok) {
        throw new Error("Failed to fetch item data: " + response.statusText);
    }

    return response.json();
};

export const fetchItemUse = async (token, itemCode) => {
    const url = `${API_URL}v2/item/use`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode: itemCode },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

// Guild deposit
export const fetchItemGDeposit = async (token, itemCode, qty) => {
    const url = `${API_URL}v2/item/action`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { action: 'gdeposit', itemCode, qty },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

// Equipment API functions

export const fetchEquipItem = async (token, itemCode, enchantLevel = 0) => {
    const url = `${API_URL}v2/v3/api/equipment/equip`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode, enchantLevel },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.error) {
                errorResult = data.error;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

export const fetchUnequipItem = async (token, itemCode, enchantLevel = 0) => {
    const url = `${API_URL}v2/v3/api/equipment/unequip`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode, enchantLevel },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.error) {
                errorResult = data.error;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

export const fetchLoadAmmo = async (token, itemCode, quantity) => {
    const url = `${API_URL}v2/v3/api/ammo/load`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode, quantity },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.error) {
                errorResult = data.error;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

export const fetchUnloadAmmo = async (token, itemCode, quantity) => {
    const url = `${API_URL}v2/v3/api/ammo/unload`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { itemCode, quantity },
    });

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.error) {
                errorResult = data.error;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};
